import React, { useState } from "react";
import BarChart from "./component/BarChart";
import VerticalBarChart from "./component/VerticalBarChart";
import { useQuery, useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import Nav from "../../components/Nav";
import Auth from "../../utils/auth";
import { Navigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import SectionHeader from "../../components/SectionHeader";
import { GET_FEEDBACK, GET_MENU_ITEM_DETAILS } from "./gql/queries";
import { PROVIDE_FEEDBACK } from "./gql/mutations";
import { GET_ME } from "../user/gql/queries";
import {useMediaQuery} from "../../utils/deviceChecker";

const Feedback = () => {
  const [provideFeedback] = useMutation(PROVIDE_FEEDBACK);
  const { register, handleSubmit, watch } = useForm({
    defaultValues: { spice: 3, oil: 3, dryness: 3, quantity: 3, frequency: 3 }
  });
  const watchedValues = watch();

  const { menuId: menuParam } = useParams();

  const { data } = useQuery(GET_ME);
  const me = data?.me;

  const { loading: feedbackLoading, data: feedbackData } = useQuery(
    GET_FEEDBACK,
    { variables: { menuId: menuParam } }
  );

  const { loading: menuLoading, error: menuError, data: menuItemData } = useQuery(
    GET_MENU_ITEM_DETAILS,
    { variables: { menuId: menuParam } }
  );

  const feedback = feedbackData?.getFeedback || [];
  const dishName = menuItemData?.getSignupsForMenuItem?.[0]?.menuItem?.dish?.dishName || '';
  const cookName = menuItemData?.getSignupsForMenuItem?.[0]?.menuItem?.cook?.fullName || '';

  const showFeedbackResults = () => {
    const feedbackResultsHeader = document.querySelector(
      ".feedbackSectionHeader"
    );
    feedbackResultsHeader.style.display = "block";
    const feedbackResults = document.querySelector(".feedbackContainer");
    feedbackResults.style.display = "flex";
    const feedbackForm = document.querySelector(".feedbackFormContainer");
    feedbackForm.style.display = "none";
    const feedbackFormHeader = document.querySelector(".feedbackFormHeader");
    feedbackFormHeader.style.display = "none";
  };

  const onSubmit = async (feedbackData) => {
    try {
      const { data } = await provideFeedback({
        variables: {
          menuItem: menuParam,
          user: me.userId,
          spicyRating: parseInt(feedbackData.spice),
          oilyRating: parseInt(feedbackData.oil),
          quantityRating: parseInt(feedbackData.quantity),
          frequencyRating: parseInt(feedbackData.frequency),
          dryRating: parseInt(feedbackData.dryness),
          feedbackComments: feedbackData.feedbackComments
        },
      });
      showFeedbackResults();
    } catch (err) {
      console.error(err);
    }
  };

  const isDesktop = useMediaQuery("(min-width: 1258px)");

  const resultsMessage = (count) => {
    if (count === 0 || count === undefined) {
      return "You are the first to provide feedback!";
    } else {
      return "Showing average from " + count + " result" + (count === 1 ? "" : "s");
    }
  };
  const feedbackCriteria = [
    { label: "Was it Spicy", field: "spice" },
    { label: "Was it Oily", field: "oil" },
    { label: "Was it Dry", field: "dryness" },
    { label: "Was it Enough", field: "quantity" },
    { label: "Is it Served Often", field: "frequency" },
  ];
  const sliderLabels = ["Too Less", "Can Be More", "Just Right", "Can Be Less", "Too Much"];
  return (
    <>
      <div className="navAndHeader">
        <Nav />
      </div>
      <h1>Feedback</h1>
      <div className="mainContainer">
        <SectionHeader
          title={`${dishName}`}
          className="sectionHeader feedbackFormHeader"
        />
        <div className="dishContainer feedbackFormContainer">
          <form className="feedbackForm" onSubmit={handleSubmit(onSubmit)}>
            {feedbackCriteria.map(({ label, field }) => {
              const value = parseInt(watchedValues[field]) || 3;
              return (
                <div className="feedbackSliderRow" key={field}>
                  <legend>{label}</legend>
                  <div className="feedbackSlider">
                    <input
                      type="range"
                      min="1"
                      max="5"
                      step="1"
                      {...register(field)}
                    />
                    <div className="sliderLabels">
                      {sliderLabels.map((label, i) => (
                        <span key={i} className={value === i + 1 ? "sliderLabelActive" : ""}>{label}</span>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="feedbackCommentsContainer">
              <label htmlFor="Additional Comments"><h4>Additional Comments</h4></label>
              <input type="text" {...register("feedbackComments")} />
            </div>
            <input type="submit" value="Submit" />
          </form>
        </div>
        <SectionHeader
          title={`Responses - ${dishName}`}
          className="feedbackSectionHeader"
        />
        <div className="feedbackContainer">
          <h4>{resultsMessage(feedback[0]?.feedbackCount)}</h4>
          {isDesktop ? (
            <BarChart feedback={feedback[0]} />
          ) : (
            <VerticalBarChart feedback={feedback[0]} />
          )}
        </div>
      </div>
    </>
  );
};

export default Feedback;
